import React from 'react';
import OpenAppPageComponent from '../../components/openApp/components/OpenAppPageComponent';
import HeaderTags from '../../common/headerTags/HeaderTags';

const headerTags =
{
    title: 'Open-App',
    meta: {
        description: 'Open-App',
        robots: 'noindex, nofollow',
    },
};

const OpenApp = () => (
    <div className="pageWrapper">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <OpenAppPageComponent />
    </div>
);

export default OpenApp;
